<template>
  <div>
    <el-date-picker
      v-model="value"
      type="datetime"
      :clearable="true"
      :placeholder="placeholder1"
      align="right"
      @input="onChange"
      >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: 'DateSelect',
  data () {
    return {
      date: null,
      placeholder1: null
    }
  },
  props: ['value', 'placeholder', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    onChange: function (value) {
      // console.log(value)
      const data = value
      this.date = data
      const input = data.getFullYear() + '-' + (data.getMonth() + 1) +
      '-' + data.getDate() + ' ' + this.addzero(data.getHours()) +
      ':' + this.addzero(data.getMinutes()) + ':' + this.addzero(data.getSeconds())
      this.$emit('input', input)
    },
    addzero: function (obj) {
      if (obj < 10) {
        return '0' + obj
      } else {
        return obj
      }
    }
  },
  mounted () {
    // console.log(this.value)
    this.date = this.value
    this.placeholder1 = this.placeholder
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DateSelect/index.vue